import * as types from '../constants/ActionTypes';
import { browserHistory } from 'react-router';
import ReactGA from 'react-ga';

import { reloadUserData, resetUserData } from './User';
import { sendToApi, sendToApiNoHeaders } from '../../lib/sendToApi';
// import { getAllUserFriends } from './Friends';
// import { getAllPosts } from './Post';

/////////////////////
// Authentication //
///////////////////

function meFromToken(tokenFromStorage) {
  //check if the token is still valid, if so, get me from the server
  const request = fetch(`/me/from/token?token=${tokenFromStorage}`, {
    method: 'POST',
    headers: {
      // JSON headers were causing parsing error in firefox
      // 'Accept': 'application/json',    
      // 'Content-Type': 'application/json',
      'Authorization': `Bearer ${tokenFromStorage}`,
    },
    body: {
      token: tokenFromStorage
    }
  }).then( response => Promise.all([response, response.json()]));
  return {
    type: types.ME_FROM_TOKEN,
    payload: request
  };
}

function meFromTokenSuccess(currentUser) {
  return {
    type: types.ME_FROM_TOKEN_SUCCESS,
    payload: currentUser
  };
}

function meFromTokenFailure(error) {
  return {
    type: types.ME_FROM_TOKEN_FAILURE,
    payload: error
  };
}

function resetToken() { 
  //used for logout
  return {
    type: types.RESET_TOKEN
  };
}

export function loadUserFromToken() {
  let token = sessionStorage.getItem('jwtToken');
  if(!token || token === '') {
    return dispatch => {
      dispatch(meFromTokenFailure('No JWT token found.'));
    }
  }
  return dispatch => {
    let response = dispatch(meFromToken(token))
    response.payload.then((payload) =>  {
      if(payload[0].status === 200) {
        //reset token (possibly new token that was regenerated by the server)
        sessionStorage.setItem('jwtToken', payload[1].token);
        dispatch(reloadUserData(payload[1].user))

        // Grab data for redux store from id
        // dispatch(getAllUserFriends(payload[1].user._id));
        // dispatch(getAllPosts(payload[1].user._id));

        dispatch(meFromTokenSuccess());
      } else {
        sessionStorage.removeItem('jwtToken'); 
        dispatch(meFromTokenFailure(payload));
      }
    }).catch((payload) => {});
  }
}

export function resetUserToken() {
  return dispatch => {
    sessionStorage.removeItem('jwtToken'); 
    dispatch(resetToken());
    dispatch(resetUserData());
  }
}


////////////
// Login //
//////////

function loginPending(loginPending) {
  return {
    type: types.LOGIN_PENDING,
    loginPending
  };
}
 
function loginSuccess(loginSuccess) {
  return {
    type: types.LOGIN_SUCCESS,
    loginSuccess
  };
}
 
function loginError(loginError) {
  return {
    type: types.LOGIN_ERROR,
    loginError
  }
}

function callLoginApi(data, callback) {
  console.log('STORE: call login api', data)

    fetch('/signup', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  }).then(function(response) {
    Promise.resolve(response.json()).then(function(value) {
      //store JWT Token to browser session storage 
      //sessionStorage = persisted only in current tab. LocalStorage = across all windows and tabs
      sessionStorage.setItem('jwtToken', value.token)
      switch (response.status) {
        case 400: 
          return callback(new Error('400: Signup Failure: Server error'));
        case 401:
          return callback(new Error('401: Login Failure: Your password did not match'));
        case 500: 
          return callback(new Error('500: There was a problem signing in.'));
        default:
          return callback();
      }
    });
  });
}

export function login(email, password) {
  let data = {
    email: email,
    password: password,
  }
  return dispatch => {
    dispatch(loginPending(true));
    dispatch(loginSuccess(false));
    dispatch(loginError(null));

    callLoginApi(data, error => {
      console.log('store: api callback')
      dispatch(loginPending(false));
      if (!error) {
        dispatch(loginSuccess(true));
        dispatch(loadUserFromToken())
        browserHistory.push('/'); 
      } else {
        dispatch(loginError(error));
      }
    });
  }
}

/////////////
// Logout //
///////////

function requestLogout() {
  return {
    type: types.LOGOUT_REQUEST,
    isLogoutPending: true,
    isAuthenticated: true
  }
}

function receiveLogout() {
  return {
    type: types.LOGOUT_SUCCESS,
    isLogoutPending: false,
    isAuthenticated: false
  }
}

// Logs the user out
export function logoutUser() {
  console.log('logout action')
  return dispatch => {
    dispatch(requestLogout())
    dispatch(resetUserToken())
    sessionStorage.removeItem('jwtToken')
    dispatch(receiveLogout())
  }
}

/////////////
// Signup //
///////////

export function signup(email, password, username) {
  let data = {
    email: email,
    password: password,
    username: username,
  }

  // This validates if the username already exists, and if not then signs in
  return dispatch => {
    dispatch(validateUsernamePending(true));
    dispatch(validateUsernameSuccess(false));
    dispatch(validateUsernameError(null, null));

    sendToApi('api/username/validate', { username: username }).then((payload) =>  {
      let usernameExists = payload[1].usernameExists;
      dispatch(validateUsernamePending(false));
      
      if(payload[0].status === 200 && !usernameExists) {
        // If username is available, initiate signup
        dispatch(validateUsernameSuccess(true));

        dispatch(signupPending(true));
        dispatch(signupSuccess(false));
        dispatch(signupError(null)); 
        callLoginApi(data, error => {
          dispatch(signupPending(false));
          if (!error) {
            dispatch(signupSuccess(true));
            dispatch(loadUserFromToken())
            browserHistory.push('/'); 
            ReactGA.event({
              category: 'Account',
              action: 'Create Account',
            });
          } else {
            dispatch(signupError(error));
          }
        });

      } else if (payload[0].status === 200 && usernameExists){
        // If username is not available
        dispatch(validateUsernameError(true, 'Username already exists'));
      } else {
        // If server error checking username
        dispatch(validateUsernameError(error, 'There was a server error validating your username. Please try again'));
      }

    }).catch((payload) => {});
  }

}

function signupPending(signupPending) {
  return {
    type: types.SIGNUP_PENDING,
    signupPending
  };
}
 
function signupSuccess(signupSuccess) {
  return {
    type: types.SIGNUP_SUCCESS,
    signupSuccess
  };
}
 
function signupError(signupError) {
  return {
    type: types.SIGNUP_ERROR,
    signupError
  }
}

////////////////////////
// Validate Username //
//////////////////////

function validateUsernamePending(validateUsernamePending) {
  return {
    type: types.VALIDATE_USERNAME_PENDING,
    validateUsernamePending
  };
}
 
// Success means that the validation finished, not that the validation passed 
function validateUsernameSuccess(validateUsernameSuccess) {
  return {
    type: types.VALIDATE_USERNAME_SUCCESS,
    validateUsernameSuccess
  };
}
 
function validateUsernameError(validateUsernameError, errorMessage) {
  return {
    type: types.VALIDATE_USERNAME_ERROR,
    validateUsernameError,
    validateUsernameErrorMessage: errorMessage,
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/Authentication.js